var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 33,
    viewBox: "0 0 122 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 23,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88873 0.235962H27.7106V14.779H5.88873V0.235962Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7999 14.779L5.88873 4.71036C8.69747 1.94294 12.5497 0.235962 16.7995 0.235962C21.0497 0.235962 24.9015 1.94331 27.7106 4.71036L16.7999 14.779Z",
    fill: "#29ABE2"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4357 26.202C26.4714 28.4163 23.8878 30.066 20.9569 30.8777C20.9565 30.8781 20.9565 30.8777 20.9565 30.8777C19.6329 31.245 18.2391 31.4408 16.7994 31.4408C8.2026 31.4408 1.23315 24.4553 1.23315 15.8384C1.23315 12.7975 2.10124 9.95929 3.60275 7.56018L3.60384 7.56127L16.7994 19.7402H16.7998L29.9954 7.56127L29.9965 7.56018C31.498 9.95929 32.3661 12.7975 32.3661 15.8384C32.3661 19.8161 30.8809 23.4467 28.4357 26.202Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9954 7.5587C29.4162 6.63246 28.742 5.77186 27.9871 4.99002C27.8961 4.89558 27.8037 4.80259 27.7106 4.71033L16.7998 14.779L5.8887 4.71033L5.88833 4.71069C5.8585 4.74059 5.82867 4.76977 5.7992 4.79967C5.59145 5.00753 5.38953 5.22122 5.19379 5.44074C4.60658 6.09896 4.07394 6.80713 3.60387 7.5587C3.60351 7.55906 3.60315 7.55979 3.60278 7.56016L3.60387 7.56125L16.7995 19.7402H16.7998L29.9954 7.56125L29.9965 7.56016C29.9961 7.55979 29.9958 7.55906 29.9954 7.5587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8203 30.0089C23.685 33.6248 32.0442 32.8498 32.0442 32.8498C29.4805 31.1579 28.1377 29.6008 28.2088 20.519L19.8203 30.0089Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6683 21H47.0483L43.6603 16.198L46.8383 11.662H44.4443L42.3303 14.854L40.1883 11.662H37.8223L41.0003 16.212L37.6123 21H39.9783L42.3303 17.584L44.6683 21ZM57.376 16.338C57.376 13.524 55.318 11.508 52.49 11.508C49.676 11.508 47.618 13.524 47.618 16.338C47.618 19.152 49.676 21.168 52.49 21.168C53.302 21.168 54.058 21 54.716 20.692L55.458 21.574L56.844 20.44L56.158 19.642C56.928 18.802 57.376 17.654 57.376 16.338ZM52.49 19.404C50.768 19.404 49.662 18.074 49.662 16.338C49.662 14.588 50.768 13.272 52.49 13.272C54.212 13.272 55.332 14.588 55.332 16.338C55.332 17.01 55.164 17.626 54.856 18.116L53.792 16.87L52.406 17.99L53.47 19.236C53.176 19.348 52.84 19.404 52.49 19.404ZM71.5931 21H73.5951V11.662H70.7951L68.5271 17.486L66.2591 11.662H63.4731V21H65.4611V14.28L68.0931 21H68.9611L71.5931 14.28V21ZM75.3657 19.684C76.2477 20.566 77.5357 21.168 79.3277 21.168C81.8477 21.168 83.0657 19.88 83.0657 18.172C83.0657 16.1 81.1057 15.638 79.5657 15.288C78.4877 15.036 77.7037 14.84 77.7037 14.21C77.7037 13.65 78.1797 13.258 79.0757 13.258C79.9857 13.258 80.9937 13.58 81.7497 14.28L82.8557 12.824C81.9317 11.97 80.6997 11.522 79.2157 11.522C77.0177 11.522 75.6737 12.782 75.6737 14.336C75.6737 16.422 77.6337 16.842 79.1597 17.192C80.2377 17.444 81.0497 17.682 81.0497 18.382C81.0497 18.914 80.5177 19.432 79.4257 19.432C78.1377 19.432 77.1157 18.858 76.4577 18.172L75.3657 19.684ZM84.5162 16.338C84.5162 19.278 86.7562 21.182 89.4862 21.182C91.1802 21.182 92.5102 20.482 93.4622 19.418V15.848H89.0102V17.556H91.5022V18.69C91.0962 19.054 90.3402 19.404 89.4862 19.404C87.7922 19.404 86.5602 18.102 86.5602 16.338C86.5602 14.574 87.7922 13.272 89.4862 13.272C90.4662 13.272 91.2642 13.79 91.6982 14.448L93.3502 13.552C92.6362 12.446 91.4182 11.508 89.4862 11.508C86.7562 11.508 84.5162 13.384 84.5162 16.338Z",
    fill: "#09090A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logo-with-text.ee9ce118aa672d7814f33db7e92fa992.svg";
export { ForwardRef as ReactComponent };